<div class="card" id="contract-down-collapse">
    <div class="card-body">
        <form [formGroup]="form">
            <ng-container formArrayName="payments">
                <ul>
                    @for (payForm of payments.controls; track payForm; let i = $index) {
                        <li [formGroup]="payForm">
                            <span class="form-text">{{payForm.get('category').value}}</span>
                            <currency-input [id]="'down-amount' + i" [control]="payForm.get('amount')"></currency-input>
                            <input type="date" class="form-control form-control-sm" formControlName="due" />
                            <div class="actions">
                                @if (isUnLock && (payForm.get('paid').value !== true)) {
                                    <button title="Delete" class="btn btn-sm btn-link" (click)="discard(i)"><span class="dripicons dripicons-trash text-danger"></span></button>
                                }
                                @if (isUnLock && payForm.valid && payForm.dirty) {
                                    <button title="Save" class="btn btn-sm btn-link" (click)="save(i)"><span class="dripicons dripicons-cloud-upload text-primary"></span></button>
                                }

                                @if (payForm.get('paid').value === true) {
                                    <span class="form-text">{{payForm.get('status').value}}</span>
                                }
                            </div>
                        </li>
                    }
                    @if (payments.controls.length > 0) {
                        <li class="totals">
                            <p class="text-left"></p>
                            <p class="text-right">{{total | currency}}</p>
                            <p></p>
                        </li>
                    }
                </ul>
            </ng-container>
        </form>
        <div class="button-bar text-right">
            @if (payments.dirty) {
            <button type="button" class="btn btn-primary btn-sm" (click)="saveAll()" id="saveAllPayments">
                @if (saving) {
                    <span class="spinner-grow spinner-grow-sm" role="status"></span>
                }
                @if (!saving) {
                    <span class="dripicons dripicons-cloud-upload"></span>
                }
                Save All
            </button>
            }
            @if (termable || (payments.length <= 0)) { 
                <button type="button" class="btn btn-success btn-sm" (click)="add($event)" id="addPayment" [disabled]="!isUnLock"><span class="dripicons dripicons-plus"></span></button>
            }
        </div>
    </div>
</div>